import { api } from './client';
export async function getCandidates(limit = 10, exclude = []) {
    const params = new URLSearchParams({ limit: String(limit) });
    if (exclude.length > 0) {
        params.set('exclude', exclude.join(','));
    }
    return api(`/api/people/candidates?${params}`);
}
export async function swipe(targetId, decision) {
    await api('/api/people/swipe', {
        method: 'POST',
        body: JSON.stringify({ targetId, decision }),
    });
}
export async function sendInvite(data) {
    await api('/api/people/invite', {
        method: 'POST',
        body: JSON.stringify(data),
    });
}
export async function getIncoming() {
    return api('/api/people/incoming');
}
export async function acceptIncoming(inviteId, responseAudioUrl) {
    await api(`/api/people/incoming/${inviteId}/accept`, {
        method: 'POST',
        body: JSON.stringify({ responseAudioUrl }),
    });
}
export async function silentIncoming(inviteId) {
    await api(`/api/people/incoming/${inviteId}/silent`, {
        method: 'POST',
    });
}
